<ion-content>
  <ion-header>
    <ion-toolbar class="ion-padding">
      <ion-title size="large">{{title}}</ion-title>
      <ion-buttons slot="end">
        <ion-button (click)="dismiss()">Close <ion-icon slot="end" name="close-outline"></ion-icon></ion-button>
      </ion-buttons>
    </ion-toolbar>
  </ion-header>
  <ion-item color="white" lines="none" class="ion-padding-horizontal">
    <div [innerHTML]="textStr"></div>
  </ion-item>
</ion-content>
